module.exports = __webpack_public_path__ + "img/ic_Upload.db75baa7.svg";